import { Injectable, OnDestroy, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { PlatformInfoService } from '@tgx/shared/services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ManagePermissionsService } from '@tgx/shared/permissions';
import { WebComponent, WebFeature } from '@tgx/shared/enums';

@Injectable({
  providedIn: 'root',
})
export class MappingGuard implements CanActivate, OnDestroy {
  private router = inject(Router);
  private platformInfoService = inject(PlatformInfoService);
  private managePermissionsService = inject(ManagePermissionsService);

  private destroy$ = new Subject<void>();
  private typeSelected: string;

  constructor() {
    // Subscribe to changes in `organizationSelected` only once in the constructor.
    this.platformInfoService.organizationSelected$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (organization) => {
        if (organization) {
          this.typeSelected = organization.typeSelected;
        }
      },
    });
    this.platformInfoService.selectedPartnerType$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (type) => {
        if (type) {
          this.typeSelected = type;
        }
      },
    });
  }

  async canActivate(): Promise<boolean> {
    // Only check permissions if selected organization type is a buyer
    if (this.typeSelected === 'buyer') {
      try {
        const permissionsVisibility = this.managePermissionsService.checkVisibility(
          WebComponent.MY_CONNECTIONS,
          WebFeature.MAPPING,
        );

        if (!permissionsVisibility.isVisible) this.router.navigateByUrl('connections');

        return permissionsVisibility.isVisible;
      } catch {
        return false;
      }
    } else {
      return true;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
